/// <amd-module name="VSSUI/Components/Header/CustomHeader" />

import * as React from "react";

import { ICustomHeaderProps } from "./Header.Props";

import { Spacing, SurfaceContext } from "VSSUI/Surface";
import { css } from "VSSUI/Util";

export class CustomHeader extends React.Component<ICustomHeaderProps> {
    public render() {
        return (
            <SurfaceContext.Consumer>
                {surfaceContext => {
                    return (
                        <>
                            <div
                                className={css(
                                    this.props.className,
                                    "bolt-header flex-row flex-noshrink flex-start",
                                    surfaceContext.horizontalClassName,
                                    surfaceContext.spacing === undefined && "bolt-header-no-spacing-defined",
                                    surfaceContext.spacing === Spacing.condensed && "bolt-header-condensed",
                                    surfaceContext.spacing === Spacing.default && "bolt-header-default",
                                    surfaceContext.spacing === Spacing.relaxed && "bolt-header-relaxed"
                                )}
                            >
                                {this.props.children}
                            </div>
                            {this.props.separator && <div className="bolt-header-separator flex-noshrink" />}
                        </>
                    );
                }}
            </SurfaceContext.Consumer>
        );
    }
}
